// Centralized email-verification check.
//
// The backend exposes the user's email-verification status on the user object
// (fetched in the Header via `/api/users/:id`). We accept a few common field
// names so this keeps working regardless of the exact backend naming.
//
// IMPORTANT: when the field is missing/undefined we treat the user as verified
// so nobody gets wrongly blocked until the backend starts returning it. Once
// the backend returns `isVerified: false` for unverified users, the gating
// (banner + blocked actions) activates automatically.
export const isUserVerified = (user) => {
  if (!user) return true;

  const raw =
    user.emailVerify ?? // TradeItFwd backend field (User model: emailVerify)
    user.isVerified ??
    user.emailVerified ??
    user.isEmailVerified ??
    user.verified ??
    user.verifiedAt;

  if (raw === undefined || raw === null) return true;

  return Boolean(raw);
};
